import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/logout.svg'
import _imports_1 from '@/assets/icons/check-black.svg'
import _imports_2 from '@/assets/images/package.png'


const _withScopeId = n => (_pushScopeId("data-v-be0b9026"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "done" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "logout-text" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headline-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "finish"
  })
], -1))
const _hoisted_7 = { class: "headline-main" }
const _hoisted_8 = { class: "headline-title" }
const _hoisted_9 = { class: "headline-code" }
const _hoisted_10 = { class: "headline-subtext" }
const _hoisted_11 = { class: "print" }
const _hoisted_12 = { class: "download-btn" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "instructions-title" }
const _hoisted_15 = { class: "instructions-content" }
const _hoisted_16 = {
  class: "instructions",
  style: {"white-space":"pre-line"}
}
const _hoisted_17 = { class: "back-to-homepage" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "package-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logout",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logoutUser('logout-by-user', true)))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("COMMON.LOGOUT")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("DONE.TITLE")), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t("DONE.SUBTITLE_CODE")) + ": " + _toDisplayString(_ctx.rmaCode), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.successMessage), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            text: _ctx.t('DONE.DOWNLOAD'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openInNewTab(_ctx.claimLetterUrl))),
            icon: "print"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("p", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args))),
          class: "bottom-text"
        }, _toDisplayString(_ctx.t("DONE.CANNOT_DOWNLOAD.HREF")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t("DONE.INSTRUCTIONS_TITLE")), 1),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.instructions), 1),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", { href: _ctx.marketUrl }, [
            _createVNode(_component_Button, {
              text: _ctx.t('DONE.HOMEPAGE') + ' ' + _ctx.market
            }, null, 8, ["text"])
          ], 8, _hoisted_18)
        ])
      ]),
      _hoisted_19
    ])
  ]))
}